import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://60459fd79ab62b6e4a676f3b134f22c8@o1388406.ingest.us.sentry.io/4509070316077056",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

emitter.on("ui-ready", () => {
  import("./main.app");  
})

emitter.on("initialized", () => {
    emitter.emit("load");
});

import("./app");


